module.exports = __webpack_public_path__ + "img/russell_graham_violin_2.6851f39e.jpg";